import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_TOUR_EXP_CREDIT_HASH,
} from 'loyalty/constants/loyaltyRoutes'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTourExpCredit(props: Props) {
  const { layout, benefitLabel } = props
  const intl = useIntl()

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="tour_exp_credit"
    heading={intl.formatMessage({
      defaultMessage: 'Tour optional extra credits',
      id: 'j5urduxHC-A_ol5qd0LZ',
      description: 'Heading for loyalty tour experience credit benefit tile',
    })}
    subtitle={benefitLabel}
    to={getLoyaltyBenefitModalPath(LOYALTY_TOUR_EXP_CREDIT_HASH)}
  />
}

export default LandingPageLoyaltyTourExpCredit
